import React, { useEffect } from 'react';
import { Modal, Form, Input, InputNumber, Switch, message } from 'antd';
import { useSales } from '../SalesContext';
import { ProductSection } from '../types';

interface SectionFormModalProps {
    visible: boolean;
    onClose: () => void;
    section: ProductSection | null;
    businessArea: 'telecomunicacao' | 'energia' | 'seguranca';
    onSuccess: () => void;
}

const SectionFormModal: React.FC<SectionFormModalProps> = ({
    visible,
    onClose,
    section,
    businessArea,
    onSuccess
}) => {
    const [form] = Form.useForm();
    const { createSection, updateSection } = useSales();

    useEffect(() => {
        if (visible) {
            if (section) {
                form.setFieldsValue(section);
            } else {
                form.resetFields();
                form.setFieldsValue({
                    business_area: businessArea,
                    is_active: true,
                    order: 0
                });
            }
        }
    }, [visible, section, businessArea, form]);

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            values.business_area = businessArea; // Ensure business area is set

            if (section) {
                await updateSection(section.id, values);
                message.success('Secção atualizada');
            } else {
                await createSection(values);
                message.success('Secção criada');
            }
            onSuccess();
        } catch (error) {
            console.error(error);
            // specific error handled in context/api
        }
    };

    return (
        <Modal
            title={section ? 'Editar Secção' : 'Nova Secção'}
            open={visible}
            onCancel={onClose}
            onOk={() => form.submit()}
            destroyOnClose
            className="admin-form-modal"
            okText="Gravar"
            cancelText="Cancelar"
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={handleSubmit}
                initialValues={{
                    name: '',
                    order: 0,
                    is_active: true
                }}
            >
                <Form.Item
                    name="name"
                    label="Nome da Secção"
                    rules={[{ required: true, message: 'Por favor insira o nome' }]}
                >
                    <Input placeholder="Ex: Internet Fixa" />
                </Form.Item>

                <Form.Item
                    name="order"
                    label="Ordem"
                    help="Menores valores aparecem primeiro"
                >
                    <InputNumber min={0} style={{ width: '100%' }} />
                </Form.Item>

                <Form.Item
                    name="is_active"
                    label="Ativo"
                    valuePropName="checked"
                >
                    <Switch />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default SectionFormModal;
